import { useSyncExternalStore } from 'react';

// How many file uploads are queued or in flight in this tab, app-wide. An
// upload flow calls `beginUpload()` per file and the returned function when that
// file is done (either way); the new-version banner reads it so it never
// suggests a reload that would cut an upload short.

let active = 0;
const listeners = new Set<() => void>();

function emit() {
  for (const l of listeners) l();
}

/** Count one upload as in progress. Call the returned function when it ends
 * (success or failure); calling it again is a no-op. */
export function beginUpload(): () => void {
  active += 1;
  emit();
  let ended = false;
  return () => {
    if (ended) return;
    ended = true;
    active -= 1;
    emit();
  };
}

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/** True while any upload in this tab is queued or in flight. */
export function useUploadsInProgress(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => active > 0,
    () => false,
  );
}
